import { Link, useLocation } from 'react-router-dom'
import twitter from 'assets/img/icons/twitter.svg'
import discord from 'assets/img/icons/discord.svg'
import youtube from 'assets/img/icons/youtube.svg'
import video from 'assets/img/footer-bg.mp4'


const PageFooter = () => {
  const {pathname} = useLocation();
  return (
    <footer className="page-footer">
      <div className='page-footer__wrapper'>
      <nav className="page-footer__nav">
        <Link to='privacies/learn-to-play' className="page-footer__nav-item" href="">Learn To Play</Link>
        <Link to='privacies/rules' className="page-footer__nav-item" href="">Game Rules</Link>
        <Link to='privacies/terms-of-use' className="page-footer__nav-item" href="">Terms & Conditions</Link>
        <Link to='privacies/privacy-policy' className="page-footer__nav-item" href="">Privacy Policy</Link>
      </nav>
      <nav className="page-footer__nav">
        <a className="page-footer__nav-item" href="">Careers</a>
        <a className="page-footer__nav-item" href="">Press</a>
        <a className="page-footer__nav-item" href="">Blog</a>
        <a className="page-footer__nav-item" href="">Contact</a>
        <a className="page-footer__nav-item" href="">Help</a>
      </nav>
      <nav className="page-footer__nav">
        <a className="page-footer__nav-item" href="https://x.com/220KGame" target='_blank' rel="noreferrer">
          <img src={twitter} alt="X (Twitter) logo" />
          X (Twitter)
        </a>
        <a className="page-footer__nav-item" href="">
          <img src={discord} alt="Discord logo" />
          Discord
        </a>
        <a className="page-footer__nav-item" href="">
          <img src={youtube} alt="Youtube logo" />
          Youtube
        </a>
      </nav>
      <p className="page-footer__copyright">10XCHI, Inc. All rights reserved.</p>
      </div>
      {
        pathname === '/' && <video className='page-footer__bg' src={video} autoPlay playsInline loop muted />
      }
    </footer>
  )
}

export default PageFooter;
